const IPIFY_URL = "https://api64.ipify.org";

export const getPublicIPAddress = async (): Promise<string> => {
  const result = await fetch(IPIFY_URL);
  return result.text();
};
